import { useState, useEffect } from 'react';
import { fetchProfileStatus } from '../../../services/api';

const useProfileCompletion = () => {
  const [profileStatus, setProfileStatus] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const loadProfileStatus = async () => {
    try {
      setLoading(true);
      const data = await fetchProfileStatus();
      setProfileStatus(data);
      setError(null);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadProfileStatus();
  }, []);

  return { profileStatus, loading, error, refreshProfile: loadProfileStatus };
};

export default useProfileCompletion;
